import { classnames } from '@/utils/classnames.ts';

import Button, { type ButtonProps } from './Button.tsx';

export interface IconButtonProps extends ButtonProps {
    // Icon-only buttons have no visible text, so a label is required for screen readers.
    'aria-label': string;
}

const IconButton = ({ variant = 'ghost', size = 'sm', className, ...props }: IconButtonProps) => (
    <Button
        variant={variant}
        size={size}
        {...props}
        className={classnames(size === 'md' ? 'w-10 px-0' : 'w-8 px-0', className)}
    />
);

export default IconButton;
